import React from 'react';
import {
	func,
	string
} from 'prop-types';
import AnswerCandidateListItem from '../AnswerCandidateListItem/index';
import SortableListBase from './SortableListBase';

const AnswerSortableList = ({ onDelete, answer, ...props }) => {
	return (
		<SortableListBase {...props} renderListItem={(val, index) => {
			return (
				<AnswerCandidateListItem index={index}
					isAnswer={val === answer}
					onDelete={() => { onDelete(index); }}
				>{val}</AnswerCandidateListItem>
			);
		}} />
	);
};

AnswerSortableList.propTypes = {
	answer : string,
	onDelete : func.isRequired
};

export default AnswerSortableList;